import { call, put, takeEvery } from "redux-saga/effects"

// Export Redux States
import {
    GET_COMPANY_USERS,
    ADD_NEW_COMPANY_USER,
    DELETE_COMPANY_USER,
    UPDATE_COMPANY_USER,
} from "./actionTypes"

import {
    getCompanyUsersSuccess,
    getCompanyUsersFail,
    addNewCompanyUserSuccess,
    addNewCompanyUserFail,
    updateCompanyUserSuccess,
    updateCompanyUserFail,
    deleteCompanyUserSuccess,
    deleteCompanyUserFail,
} from "./actions"

// Include Helper Files with API Calls
import {
    getCompanyUsers,
    addNewCompanyUser,
    updateCompanyUser,
    deleteCompanyUser,
} from "../../helpers/fakebackend_helper"

function* fetchCompanyUsers() {
    try {
        const response = yield call(getCompanyUsers)
        yield put(getCompanyUsersSuccess(response))
    } catch (error) {
        yield put(getCompanyUsersFail(error))
    }
}

function* onAddNewCompanyUser({ payload: user }) {
    try {
        const response = yield call(addNewCompanyUser, user)
        yield put(addNewCompanyUserSuccess(response.user))
    } catch (error) {
        yield put(addNewCompanyUserFail(error))
    }
}

function* onUpdateCompanyUser({ payload: user }) {
    try {
        const response = yield call(updateCompanyUser, user)
        yield put(updateCompanyUserSuccess(user)) // Or response.user if available
    } catch (error) {
        yield put(updateCompanyUserFail(error))
    }
}

function* onDeleteCompanyUser({ payload: user }) {
    try {
        yield call(deleteCompanyUser, user.id)
        yield put(deleteCompanyUserSuccess(user.id))
    } catch (error) {
        yield put(deleteCompanyUserFail(error))
    }
}

function* companyUsersSaga() {
    yield takeEvery(GET_COMPANY_USERS, fetchCompanyUsers)
    yield takeEvery(ADD_NEW_COMPANY_USER, onAddNewCompanyUser)
    yield takeEvery(UPDATE_COMPANY_USER, onUpdateCompanyUser)
    yield takeEvery(DELETE_COMPANY_USER, onDeleteCompanyUser)
}

export default companyUsersSaga
